module.exports = __webpack_public_path__ + "img/icon6.2f2e46c4.png";